import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, ShieldCheck } from 'lucide-react';
const HeaderEVHiddenEnemy = () => {
  return <header className="bg-white" data-id="element-3531">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-3532"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-3533">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-3534">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-3535">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-3536">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-3537">
          <div className="text-left" data-id="element-3538">VOL. 128, NO. 47</div>
          <div className="text-left sm:text-center" data-id="element-3539">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-3540">
            TECHNOLOGY & HEALTH SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-3541">
        <div className="max-w-4xl mx-auto" data-id="element-3542">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-3543">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-3544">
            What's Happening to Your Body Every Time You Sit in Your Electric
            Vehicle
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-3545">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-3546">
              <img src="https://cdn.magicpatterns.com/uploads/8wFrT18PYaHZAC4k17S4vD/1.png" alt="Michael Torres" className="w-full h-full object-cover" data-id="element-3547" />
            </div>
            <div className="flex-1" data-id="element-3548">
              <div className="flex items-center" data-id="element-3549">
                <div className="font-medium text-gray-900 text-lg" data-id="element-3550">
                  By Michael Torres, P.E.
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-3551">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-3552" />
                  <span className="text-xs ml-1 font-medium" data-id="element-3553">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-3554">
                San Diego, CA • Electrical Systems Engineer • 41 Years Old •
                Raytheon Integrated Defense Systems
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-3555">
                <div className="flex items-center mr-4" data-id="element-3556">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-3557" />
                  <span data-id="element-3558">12 min read</span>
                </div>
                <div className="flex items-center" data-id="element-3559">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-3560" />
                  <span data-id="element-3561">26,814 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-3562">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-3563" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-3564">
                  Patricia Chen, RN, MSN
                </span>
              </div>
            </div>
          </div>

          <div className="mb-5" data-id="element-3565">
            <img src="https://cdn.magicpatterns.com/uploads/oggJp2s5BSfVsuJfeADjP3/2.png" alt="Tesla silhouette at sunset" className="w-full rounded-lg shadow-md" data-id="element-3566" />
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-3567">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-3568">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-3569">
              "What a Raytheon electromagnetic engineer found when his daughter
              kept getting sick after every drive — and what he wishes every EV
              family knew before getting in the car.
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-3570">
              — shared with 9,000+ EV owners across two forums."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-3571">
            <div className="mb-1 flex items-center" data-id="element-3572">
              <span className="font-medium mr-2" data-id="element-3573">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-3574">
              <span className="font-medium mr-2" data-id="element-3575">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderEVHiddenEnemy;